import { useCallback, useEffect, useState } from 'react';
import { getSessionValue, setSessionValue } from '..';
export const useSessionState = (key, defaultValue) => {
    const getValue = useCallback(() => {
        const value = getSessionValue(key, defaultValue);
        return value;
    }, [key, defaultValue]);
    const [storedValue, setStoredValue] = useState(getValue);
    useEffect(() => {
        let unmounting = false;
        setTimeout(() => {
            const newValue = getValue();
            if (!unmounting && JSON.stringify(storedValue) !== JSON.stringify(newValue)) {
                setStoredValue(newValue);
            }
        }, 0);
        return () => {
            unmounting = true;
        };
    }, [storedValue, getValue]);
    const setValue = (value) => {
        if (typeof value === 'function') {
            value = value(storedValue);
        }
        setStoredValue(value ?? defaultValue);
        setSessionValue(key, value);
    };
    return [storedValue, setValue];
};
